import React, { forwardRef } from 'react'

export type IframeAttributes = {
  src: string
  height?: string
  title?: string
  allow?: string
  style?: React.CSSProperties
}

const Iframe = forwardRef<HTMLIFrameElement, IframeAttributes>(
  ({ src, height, title, allow, style: propsStyle }, ref) => {
    const style: React.CSSProperties = {
      border: 'none',
      display: 'block',
      width: '100%',
      padding: 0,
      margin: 0,
      flex: 1,
      ...propsStyle
    }

    return (
      <iframe
        ref={ref}
        src={src}
        height={height}
        title={title}
        allow={allow}
        style={style}
      />
    )
  }
)

Iframe.displayName = 'Iframe'

export default Iframe
